import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name, bool_type, int32_type, record_type, option_type, union_type, string_type, class_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { Infra_urlForMediaImgSafe, TeamStatus, QuizStatus, RESP$1_$reflection, MainModels_QuizRegRecord_$reflection } from "../shared/Shared.fs.js";
import { splitByLines, urlForTeam, apiCmd, noCmd } from "./Common.fs.js";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library.4.10.0/String.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import * as react from "react";
import { ofArray, singleton } from "./fable_modules/fable-library.4.10.0/List.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { equals } from "./fable_modules/fable-library.4.10.0/Util.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { footerHero } from "./MainTemplates.fs.js";
import { toString } from "./fable_modules/fable-library.4.10.0/Date.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Exn", "GetRegModelResp", "OpenRegForm", "SubmitRegFrom", "CancelRegFrom", "RegFromTeamName", "RegisterTeamResp"];
    }
}

export function Msg_$reflection() {
    return union_type("MainReg.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [["Item", RESP$1_$reflection(MainModels_QuizRegRecord_$reflection())]], [], [], [], [["Item", string_type]], [["Item", RESP$1_$reflection(MainModels_QuizRegRecord_$reflection())]]]);
}

export class Model extends Record {
    constructor(Error$, Quiz, RegForm) {
        super();
        this.Error = Error$;
        this.Quiz = Quiz;
        this.RegForm = RegForm;
    }
}

export function Model_$reflection() {
    return record_type("MainReg.Model", [], Model, () => [["Error", string_type], ["Quiz", option_type(MainModels_QuizRegRecord_$reflection())], ["RegForm", option_type(RegForm_$reflection())]]);
}

export class RegForm extends Record {
    constructor(QuizId, TeamName, IsSending, Error$) {
        super();
        this.QuizId = (QuizId | 0);
        this.TeamName = TeamName;
        this.IsSending = IsSending;
        this.Error = Error$;
    }
}

export function RegForm_$reflection() {
    return record_type("MainReg.RegForm", [], RegForm, () => [["QuizId", int32_type], ["TeamName", string_type], ["IsSending", bool_type], ["Error", string_type]]);
}

export function openRegForm(cm) {
    let matchValue_2;
    const matchValue = cm.Quiz;
    if (matchValue == null) {
        return cm;
    }
    else {
        const quiz = matchValue;
        const matchValue_1 = cm.RegForm;
        let matchResult, regForm_1;
        if (matchValue_1 != null) {
            if (matchValue_1.IsSending) {
                matchResult = 0;
                regForm_1 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return cm;
            default:
                return new Model(cm.Error, cm.Quiz, new RegForm(quiz.QuizId, (matchValue_2 = quiz.Comp, (matchValue_2 != null) ? matchValue_2.TeamName : ""), false, ""));
        }
    }
}

export function cancelRegForm(cm) {
    const matchValue = cm.RegForm;
    let matchResult, regForm_1;
    if (matchValue != null) {
        if (matchValue.IsSending) {
            matchResult = 0;
            regForm_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return cm;
        default:
            return new Model(cm.Error, cm.Quiz, void 0);
    }
}

export function submitRegForm(api, cm) {
    const matchValue = cm.RegForm;
    if (matchValue != null) {
        if (matchValue.IsSending) {
            const regForm_2 = matchValue;
            return noCmd(cm);
        }
        else if (!validateForm(matchValue)) {
            const regForm_3 = matchValue;
            return noCmd(cm);
        }
        else {
            const regForm_4 = matchValue;
            return apiCmd(api.registerTeam, {
                TeamName: regForm_4.TeamName,
            }, (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(0, [Item_1])), new Model(cm.Error, cm.Quiz, new RegForm(regForm_4.QuizId, regForm_4.TeamName, true, regForm_4.Error)));
        }
    }
    else {
        return noCmd(cm);
    }
}

export function formError(txt, cm) {
    const matchValue = cm.RegForm;
    if (matchValue != null) {
        const regForm = matchValue;
        return new Model(cm.Error, cm.Quiz, new RegForm(regForm.QuizId, regForm.TeamName, false, txt));
    }
    else {
        return cm;
    }
}

export function formTeamName(txt, cm) {
    const matchValue = cm.RegForm;
    if (matchValue != null) {
        const regForm = matchValue;
        return new Model(cm.Error, cm.Quiz, new RegForm(regForm.QuizId, txt, regForm.IsSending, regForm.Error));
    }
    else {
        return cm;
    }
}

export function validateForm(regForm) {
    return !isNullOrWhiteSpace(regForm.TeamName);
}

export function init(api, user) {
    return apiCmd(api.getRegModel, void 0, (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(0, [Item_1])), new Model("", void 0, void 0));
}

export function update(api, user, msg, cm) {
    let matchResult, res_2, txt_2, quiz, txt_3, txt_4, ex;
    switch (msg.tag) {
        case 2: {
            matchResult = 1;
            break;
        }
        case 4: {
            matchResult = 2;
            break;
        }
        case 3: {
            matchResult = 3;
            break;
        }
        case 5: {
            matchResult = 4;
            txt_2 = msg.fields[0];
            break;
        }
        case 6: {
            if (msg.fields[0].Value.tag === 1) {
                matchResult = 6;
                txt_3 = msg.fields[0].Value.fields[0];
            }
            else {
                matchResult = 5;
                quiz = msg.fields[0].Value.fields[0];
            }
            break;
        }
        case 0: {
            let activePatternResult;
            const msg_1 = msg;
            const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
            if (pi_1 == null) {
                activePatternResult = void 0;
            }
            else {
                const pi$0027 = pi_1;
                let msgType;
                let copyOfStruct = msg_1;
                msgType = Msg_$reflection();
                if (isUnion(msgType)) {
                    const objArray = getUnionFields(msg_1, msgType)[1];
                    if (objArray.length === 1) {
                        try {
                            const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                            activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                        }
                        catch (matchValue) {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                else {
                    activePatternResult = void 0;
                }
            }
            if (activePatternResult != null) {
                matchResult = 7;
                txt_4 = activePatternResult;
            }
            else {
                matchResult = 8;
                ex = msg.fields[0];
            }
            break;
        }
        default:
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 0;
                res_2 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 7;
                    txt_4 = activePatternResult_1;
                }
                else {
                    matchResult = 9;
                }
            }
    }
    switch (matchResult) {
        case 0:
            return noCmd(new Model(cm.Error, res_2, cm.RegForm));
        case 1:
            return noCmd(openRegForm(cm));
        case 2:
            return noCmd(cancelRegForm(cm));
        case 3:
            return submitRegForm(api, cm);
        case 4:
            return noCmd(formTeamName(txt_2, cm));
        case 5:
            return noCmd(new Model(cm.Error, quiz, void 0));
        case 6:
            return noCmd(formError(txt_3, cm));
        case 7:
            return noCmd(new Model(txt_4, cm.Quiz, cm.RegForm));
        case 8:
            return noCmd(new Model(ex.message, cm.Quiz, cm.RegForm));
        default:
            return noCmd(cm);
    }
}

export function levelWithRegisterBtn(dispatch, l10n) {
    return singleton(react.createElement("a", {
        className: "button is-primary is-fullwidth",
        onClick: (_arg) => {
            dispatch(new Msg(2, []));
        },
    }, l10n.Register));
}

export function levelWithRegistrationInfo(dispatch, quiz, comp, l10n) {
    return toList(delay(() => {
        let children_28, children_8, children_6, children_26, children_24, children_18, children_22;
        return append(singleton_1((children_28 = [(children_8 = [(children_6 = [react.createElement("th", {}, l10n.RegisteredAs), react.createElement("th", {}, l10n.Status), react.createElement("th", {})], react.createElement("tr", {}, ...children_6))], react.createElement("thead", {}, ...children_8)), (children_26 = [(children_24 = [react.createElement("td", {}, comp.TeamName), (children_18 = toList(delay(() => {
            const matchValue = comp.TeamStatus;
            return (matchValue.tag === 1) ? singleton_1(react.createElement("span", {
                className: "tag is-success is-light",
            }, l10n.Confirmed)) : ((matchValue.tag === 2) ? singleton_1(react.createElement("span", {
                className: "tag is-danger is-light",
            }, l10n.Rejected)) : singleton_1(react.createElement("span", {
                className: "tag is-warning is-light",
            }, l10n.Pending)));
        })), react.createElement("td", {}, ...children_18)), (children_22 = toList(delay(() => {
            let children_20;
            return equals(quiz.Status, new QuizStatus(0, [])) ? singleton_1((children_20 = [Fa_i(singleton(new Fa_IconOption(11, ["far fa-edit"])), [])], react.createElement("a", {
                className: "button is-small",
                title: l10n.Edit,
                onClick: (_arg) => {
                    dispatch(new Msg(2, []));
                },
            }, ...children_20))) : empty();
        })), react.createElement("td", {}, ...children_22))], react.createElement("tr", {}, ...children_24))], react.createElement("tbody", {}, ...children_26))], react.createElement("table", {
            className: "table",
        }, ...children_28))), delay(() => {
            let props_30, children_30;
            return equals(comp.TeamStatus, new TeamStatus(1, [])) ? singleton_1((props_30 = [new HTMLAttr(65, ["button is-success is-light is-fullwidth"]), new HTMLAttr(94, [urlForTeam(quiz.QuizId, comp.TeamId, comp.EntryToken)])], (children_30 = [(l10n.Enter + " ") + quiz.Name], react.createElement("a", keyValueList(props_30, 1), ...children_30)))) : empty();
        }));
    }));
}

export function levelWithEditForm(dispatch, settings, quiz, regForm, l10n) {
    let props_12, children_10;
    return ofArray([(props_12 = [new HTMLAttr(65, ["field has-addons is-light"]), ["style", {
        width: "100%",
    }]], (children_10 = toList(delay(() => {
        let props_2, children, props;
        return append(singleton_1((props_2 = [Helpers_classList([["control", true], ["is-expanded", true], ["is-loading", regForm.IsSending]])], (children = [(props = [Helpers_classList([["input", true], ["is-small", true], ["is-danger", regForm.Error !== ""]]), new HTMLAttr(159, ["text"]), new HTMLAttr(128, [l10n.TeamName]), new HTMLAttr(115, [64]), ["ref", (e) => {
            Internal_updateInputValue(regForm.TeamName, e);
        }], new HTMLAttr(79, [regForm.IsSending]), new DOMAttr(9, [(ev) => {
            dispatch(new Msg(5, [ev.target.value]));
        }])], react.createElement("input", keyValueList(props, 1)))], react.createElement("p", keyValueList(props_2, 1), ...children)))), delay(() => {
            let children_4, children_2;
            const isDisabled = regForm.IsSending ? true : !validateForm(regForm);
            return append(singleton_1((children_4 = [(children_2 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-check"])), [])], react.createElement("a", {
                className: "button is-small",
                disabled: isDisabled,
                onClick: (_arg) => {
                    dispatch(new Msg(3, []));
                },
            }, ...children_2))], react.createElement("p", {
                className: "control",
            }, ...children_4))), delay(() => {
                let children_8, children_6;
                return singleton_1((children_8 = [(children_6 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-times"])), [])], react.createElement("a", {
                    className: "button is-small",
                    disabled: regForm.IsSending,
                    onClick: (_arg_1) => {
                        dispatch(new Msg(4, []));
                    },
                }, ...children_6))], react.createElement("p", {
                    className: "control",
                }, ...children_8)));
            }));
        }));
    })), react.createElement("div", keyValueList(props_12, 1), ...children_10))), react.createElement("p", {
        className: "help is-danger",
    }, regForm.Error)]);
}

export function view(dispatch, user, settings, model, l10n) {
    let children_20, children_18;
    const children_22 = [(children_20 = [(children_18 = toList(delay(() => {
        let children_14, children_2, children_12, children_10, children_8;
        return append(singleton_1((children_14 = [(children_2 = [react.createElement("div", {
            className: "navbar-item is-paddingleft is-hidden-desktop",
        }, user.Name)], react.createElement("div", {
            className: "navbar-brand",
        }, ...children_2)), (children_12 = [(children_10 = [(children_8 = toList(delay(() => {
            let matchValue, url, children_4, props_4;
            return append((matchValue = user.PictureUrl, (matchValue == null) ? (empty()) : ((url = matchValue, singleton_1((children_4 = [(props_4 = [new HTMLAttr(65, ["is-rounded"]), ["style", {
                height: "50px",
                width: "50px",
                maxHeight: "50px",
            }], new HTMLAttr(149, [url])], react.createElement("img", keyValueList(props_4, 1)))], react.createElement("figure", {
                className: "image",
            }, ...children_4)))))), delay(() => {
                let props_8;
                return singleton_1((props_8 = [["style", {
                    marginLeft: "5px",
                }]], react.createElement("span", keyValueList(props_8, 1), user.Name)));
            }));
        })), react.createElement("div", {
            className: "navbar-item",
        }, ...children_8))], react.createElement("div", {
            className: "navbar-end",
        }, ...children_10))], react.createElement("div", {
            className: "navbar-menu",
        }, ...children_12))], react.createElement("nav", {
            className: "navbar is-transparent is-spaced",
            role: "navigation",
            "aria-label": "dropdown navigation",
        }, ...children_14))), delay(() => {
            const matchValue_1 = model.Quiz;
            return (matchValue_1 == null) ? ((model.Error !== "") ? singleton_1(react.createElement("span", {
                className: "has-text-danger",
            }, model.Error)) : singleton_1("Loading ...")) : quizView(dispatch, settings, matchValue_1, model.RegForm, l10n);
        }));
    })), react.createElement("div", {
        className: "container has-text-centered",
    }, ...children_18))], react.createElement("div", {
        className: "hero-head",
    }, ...children_20)), footerHero];
    return react.createElement("section", {
        className: "hero is-shadowless is-fullheight",
    }, ...children_22);
}

export function quizView(dispatch, settings, quiz, regForm, l10n) {
    let props_4, children, props_2, children_6, children_4, children_20, props_32, children_22;
    return ofArray([react.createElement("br", {}), (props_4 = [new HTMLAttr(65, ["image is-128x128"]), ["style", {
        display: "inline-block",
    }]], (children = [(props_2 = [new HTMLAttr(149, [Infra_urlForMediaImgSafe(settings.MediaHost, quiz.ImgKey)])], react.createElement("img", keyValueList(props_2, 1)))], react.createElement("figure", keyValueList(props_4, 1), ...children))), react.createElement("br", {}), react.createElement("h3", {
        className: "title is-3",
    }, quiz.Name), (children_6 = [(children_4 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-door-open"])), []), " " + l10n.Registration], react.createElement("span", {}, ...children_4))], react.createElement("h4", {
        className: "subtitle is-4",
    }, ...children_6)), (children_20 = toList(delay(() => {
        let children_10;
        return append(singleton_1((children_10 = toList(delay(() => {
            let matchValue;
            return append((matchValue = quiz.StartTime, (matchValue == null) ? singleton_1("???") : singleton_1(toString(matchValue, "yyyy-MM-dd HH:mm"))), delay(() => append(equals(quiz.Status, new QuizStatus(1, [])) ? append(singleton_1(" "), delay(() => singleton_1(react.createElement("span", {
                className: "tag is-danger is-light",
            }, "live")))) : empty(), delay(() => singleton_1(react.createElement("br", {}))))));
        })), react.createElement("p", {
            className: "subtitle is-5",
        }, ...children_10))), delay(() => {
            let children_12;
            return append(singleton_1((children_12 = splitByLines(quiz.Description), react.createElement("p", {}, ...children_12))), delay(() => append((quiz.EventPage !== "") ? singleton_1(react.createElement("a", {
                href: quiz.EventPage,
            }, l10n.Details)) : empty(), delay(() => ((quiz.Information !== "") ? append(singleton_1(react.createElement("br", {})), delay(() => {
                let children_18, children_16;
                return singleton_1((children_18 = [(children_16 = splitByLines(quiz.Information), react.createElement("p", {}, ...children_16))], react.createElement("div", {
                    className: "notification is-info",
                }, ...children_18)));
            })) : empty())))));
        }));
    })), react.createElement("div", {
        className: "notification is-white",
    }, ...children_20)), (props_32 = [["style", {
        width: "320px",
        display: "inline-block",
    }]], (children_22 = toList(delay(() => {
        if (regForm == null) {
            const matchValue_1 = quiz.Comp;
            if (matchValue_1 == null) {
                if (!equals(quiz.Status, new QuizStatus(2, []))) {
                    return levelWithRegisterBtn(dispatch, l10n);
                }
                else {
                    return empty();
                }
            }
            else {
                return levelWithRegistrationInfo(dispatch, quiz, matchValue_1, l10n);
            }
        }
        else {
            return levelWithEditForm(dispatch, settings, quiz, regForm, l10n);
        }
    })), react.createElement("div", keyValueList(props_32, 1), ...children_22)))]);
}

